import type { Country } from '@acs/shared';

/** Dialing prefix pre-filled into a phone field per business country (doc 12 §6).
 * A starting value, not a lock — overwriteable for foreign-number clients. */
export const DIAL_PREFIX: Record<Country, string> = { FR: '+33', DE: '+49', PL: '+48' };

/** Normalise the typed phone: strip spaces/dashes/dots. A national `0…` number
 * is NOT auto-converted — guessing the country is how wrong records are born
 * (doc 12 §6), so the caller validates and hints instead. */
export function normalizePhone(raw: string): string {
  return raw.replace(/[\s.\-()]+/g, '');
}
